<template>
  <div class="sm:hidden sticky py-4 px-1 pb-0 -m-4 mb-0 -mt-5 top-0 bg-white z-10">
    <div class="font-semibold flex">
      <button class="ds-modal__close_button ml-2 -mt-1 -mb-2" aria-label="Close" @click="emit('close')">
        <ChevronLeftIcon class="h-6 w-6" />
      </button>
      <div class="text-center grow pl-3 mr-10" data-test-id="reviews-modal--mobile-title">
        {{ props.venueName }}
      </div>
    </div>

    <div class="flex item-center border-0 border-t border-b border-solid border-grey-300 -mx-1 px-4 py-2 mt-4 mb-4">
      <div class="w-1/2 flex items-center justify-center">
        <div class="flex items-center font-semibold text-2xl text-green mr-2">
          <StarIcon class="h-6 w-6" />
          <div class="ml-2">
            {{ data.totalScore }}
          </div>
        </div>
        <div class="text-grey-600 text-xs">
          out of 5
        </div>
      </div>
      <div class="w-1/2 text-center">
        <div class="font-semibold">
          {{ scoreName }}
        </div>
        <div class="text-grey-600 mt-1 text-xs">
          Based on {{ data.ratings }} verified {{ data.ratings > 1 ? 'reviews' : 'review' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import StarIcon from '@tagvenue/icons/24/bold/shapes/star-01.svg';
import ChevronLeftIcon from '@tagvenue/icons/24/line/arrows/chevron-left.svg';
import { computed } from 'vue';

const emit = defineEmits(['close']);

const props = defineProps({
  venueName: {
    type: String,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
});

const scoreName = computed(() => {
  const score = props.data.totalScore;

  if (score >= 4.5) {
    return 'Superb';
  }
  if (score >= 4.25) {
    return 'Excellent';
  }
  if (score >= 4) {
    return 'Very good';
  }
  if (score >= 3.5) {
    return 'Good';
  }
  return 'Review score';
});
</script>
